(function () {
  angular.module('app.attendance-analytics.subject-grade-comparisons', []);

})();